import { render, staticRenderFns } from "./NavMenuSectionTitle.vue?vue&type=template&id=4a1ffa84&scoped=true&"
import script from "./NavMenuSectionTitle.vue?vue&type=script&lang=js&"
export * from "./NavMenuSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuSectionTitle.vue?vue&type=style&index=0&id=4a1ffa84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ffa84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
